var config = {
	// api请求地址
	baseUrl: 'https://danci.xing-peng.com/index.php/api',
	// 图片域名
	imgDomain: 'https://danci.xing-peng.com',
	//上传文件地址
	uploadUrl: '',
};

export default config;